import { useEffect } from 'react'
import { useSwipeable } from 'react-swipeable'

import { IconButton, IconX } from '@vtex/shoreline'

import { SIDE_PANEL_PORTAL_ID } from '~/constants'

import type { SidePanelProps } from '../types'

import * as S from './styles'

const SIDE_PANEL_OPEN_CLASS = 'sidePanel__open'

const SidePanel: React.FC<SidePanelProps> = ({
  message,
  style,
  onClose = () => undefined
}) => {
  const { content, title = null, callbackRemove: callback } = message

  const isMobileDevice = /Mobi|Android|iPhone|iPad|iPod/i.test(
    navigator.userAgent
  )

  const handleClose = () => {
    onClose(callback)
  }

  useEffect(() => {
    document.body.classList.add(SIDE_PANEL_OPEN_CLASS)
    document.body.style.overflow = 'hidden'

    return () => {
      if (!document.getElementById(SIDE_PANEL_PORTAL_ID)?.children?.length) {
        document.body.classList.remove(SIDE_PANEL_OPEN_CLASS)
        document.body.style.overflow = ''
      }
    }
  }, [message])

  const handlers = useSwipeable({
    trackMouse: true,
    preventScrollOnSwipe: true,
    onSwipedRight: eventData => {
      const { absX, absY, velocity } = eventData

      const isSwipe = absX > 50 && absY < 20 && velocity > 0.3

      if (isSwipe && isMobileDevice) {
        handleClose()
      }
    }
  })

  return (
    <S.AnimatedContainer style={style} {...handlers}>
      <S.Container data-size={message.size}>
        <S.Title id={`side-panel-${message?.id}-title`}>
          {title && <strong>{title}</strong>}
          <IconButton
            label="Close side panel"
            variant="tertiary"
            onClick={handleClose}
            style={{
              zIndex: 9999,
              marginLeft: 'auto'
            }}
          >
            <IconX />
          </IconButton>
        </S.Title>

        <S.Content>{content}</S.Content>
      </S.Container>
    </S.AnimatedContainer>
  )
}

export default SidePanel
